import { SigninResponse } from "oidc-client";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { CallbackComponent } from "redux-oidc";
import { getUserManager } from "../../auth";
import { Loader } from "../navigation";

interface SignInCallbackHandlerProps extends RouteComponentProps<any> {
  onSignInSuccess: (signInResponse: SigninResponse) => void;
  onSignInError: (error: Error) => void;
}

export const SignInCallbackHandlerComponent = (props: SignInCallbackHandlerProps) => {
  const { onSignInSuccess, onSignInError } = props;

  return (
    <CallbackComponent
      userManager={getUserManager()}
      // Need to cast as any since the redux-oidc typings are incorrect
      successCallback={onSignInSuccess as any}
      errorCallback={onSignInError}
    >
      <Loader loadingText={"Completing Sign-in"} />
    </CallbackComponent>
  );
};

export const SignInCallbackHandler = SignInCallbackHandlerComponent;
